import React, { useEffect } from 'react';
import qs from 'qs';
import SpinnerFull from 'Src/components/SpinnerFull';
import { set, DEFAULT_EMAIL } from 'Src/storage';

const Defaulter = ({ history, match }) => {
  useEffect(() => {
    const { location = {} } = history;
    const { params = {} } = match;
    const { version = 'v1' } = params;
    const { search = '' } = location;
    if (search) {
      const parsed = qs.parse(search, { ignoreQueryPrefix: true });
      const { email } = parsed;
      set(DEFAULT_EMAIL, email);
    }
    history.replace(`/${version}`);
  }, []);

  return (
    <SpinnerFull />
  );
};

export default Defaulter;
